/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useLayoutEffect, useRef } from "react";

const PUBSUB_WS_URL = import.meta.env.VITE_PUBSUB_URL.replace("https://", "wss://");

interface Props<T> {
  endpoint: string;
  skip?: boolean;
  onData: (data: T) => void;
}

export const useSub = <T = Record<string, any>>({
  endpoint,
  skip,
  onData,
}: Props<T>) => {
  const memoizedFunction = useRef(onData);

  useLayoutEffect(() => {
    memoizedFunction.current = onData;
  }, [onData]);

  useEffect(() => {
    if (skip) return;

    const ws = new WebSocket(`${PUBSUB_WS_URL}${endpoint}`);

    ws.onmessage = ({ data }) => {
      try {
        const parsed = JSON.parse(data as string);
        memoizedFunction.current(parsed.data ?? parsed);
      } catch {}
    };

    ws.onerror = (error) => console.error(error);

    return () => ws.close();
  }, [endpoint, skip]);
};
